import { ChevronDown } from 'lucide-react';

import { toolsLinks } from '@/shared/config/tools';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/DropdownMenu';
import type { User } from '@/lib/api/users';
import { UserAvatar } from '@/pages/groups/UserAvatar';

import { dropdownContentClass } from './DesktopSidebar.styles';

// В выпадашке шеврона оставляем только инструменты, которым нет места
// отдельным пунктом навбара.
const HEADER_TOOL_IDS = ['eds', 'time-report'];

type DesktopSidebarHeaderProps = {
  avatarOpen: boolean;
  user?: User;
  onAvatarOpenChange: (open: boolean) => void;
  onNavigate: (to: string) => void;
};

export function DesktopSidebarHeader({
  avatarOpen,
  user,
  onAvatarOpenChange,
  onNavigate,
}: DesktopSidebarHeaderProps) {
  return (
    <DropdownMenu open={avatarOpen} onOpenChange={onAvatarOpenChange}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex w-full items-center gap-2 rounded-[12px] bg-[#f9f9fd] px-[11px] py-[10px] text-left shadow-[0_8px_22px_rgba(17,24,39,0.035)] transition-colors hover:bg-[#F8F9FB] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#102653]/20 h-[40px]"
        >
          {user ? (
            <UserAvatar user={user} size="lg" />
          ) : (
            <div className="size-8 shrink-0 animate-pulse rounded-full bg-gray-200" />
          )}
          <span className="font-normal leading-none text-[#B58E60] text-[clamp(14px,1.9vh,17px)]">
            DOIT
          </span>
          <ChevronDown
            className="ml-auto size-5 text-[#313846]"
            strokeWidth={1.8}
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="start"
        className={`${dropdownContentClass} w-[var(--radix-dropdown-menu-trigger-width)] min-w-[var(--radix-dropdown-menu-trigger-width)]`}
      >
        {toolsLinks
          .filter((item) => HEADER_TOOL_IDS.includes(item.id))
          .map((item) => (
            <DropdownMenuItem
              key={item.id}
              className="cursor-pointer text-[calc(13px*var(--nav-scale,1))] font-normal focus:bg-[#F6F7FA] focus:text-[#17244A]"
              onSelect={() => onNavigate(`/tools/${item.id}`)}
            >
              {item.label}
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
